/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * 代理案件 View Model
 */
export interface SubstitutionCaseViewModel { 
    /**
     * 流程ID
     */
    processId?: string;
    /**
     * 系統ID
     */
    systemId?: number;
    /**
     * 系統代碼
     */
    systemCode?: string;
    /**
     * 系統名稱
     */
    systemName?: string;
    /**
     * 系統URL
     */
    systemHostUrl?: string;
    /**
     * 功能ID
     */
    systemFunctionId?: number;
    /**
     * 功能名稱
     */
    functionName?: string;
    /**
     * 功能代碼
     */
    functionCode?: string;
    /**
     * 功能URL
     */
    entryUrl?: string;
    /**
     * 案件來源單位ID
     */
    applyDepartmentId?: number;
    /**
     * 案件來源單位名稱
     */
    applyDepartmentName?: string;
    /**
     * 被代理人
     */
    principalSubstitute?: string;
    /**
     * 被代理人姓名
     */
    principalSubstituteName?: string;
    /**
     * 代理人
     */
    substitute?: string;
    /**
     * 代理人姓名
     */
    substituteName?: string;
    /**
     * 代理期間起日
     */
    substituteFrom?: Date;
    /**
     * 代理期間迄日
     */
    substituteTo?: Date;
}